export const SET_ASPECT_TO_DISPLAY = 'SET_ASPECT_TO_DISPLAY';

export const setAspectToDisplay = (aspectToDisplay: string) => ({
  type: SET_ASPECT_TO_DISPLAY,
  data: aspectToDisplay,
});
